import { FC, PropsWithChildren } from 'react';
import { SPACINGS } from 'shared/styles/variables';
import styled from 'styled-components';

import Button, { ButtonType } from 'inquiry/components/Button';
import ButtonBase from 'inquiry/components/ButtonBase';
import useInputCapture from 'lib/hooks/useInputCapture';
import { ButtonComponentStyles } from 'lib/interfaces/ui-components';

const StyledButton = styled(Button)`
  margin-bottom: ${SPACINGS.base * 2}px;
  :last-of-type {
    margin-bottom: 0;
  }
`;

interface ButtonInputCaptureProps {
  buttonType?: ButtonType;
  capture?: 'user' | 'environment';
  disabled?: boolean;
  handleSelectImage: (file: File) => void;
  id: string;
  isPending?: boolean;
  styles?: ButtonComponentStyles;
  'aria-label'?: string;
  'data-test'?: string;
}

const ButtonInputCapture: FC<PropsWithChildren<ButtonInputCaptureProps>> = ({
  buttonType,
  capture,
  children,
  disabled,
  id,
  isPending,
  handleSelectImage,
  styles,
  'aria-label': ariaLabel,
  'data-test': dataTest,
}) => {
  const { inputCaptureProps, buttonProps } = useInputCapture({
    onSelectImage: handleSelectImage,
    capture,
    disabled,
  });

  if (styles != null) {
    return (
      <>
        <input {...inputCaptureProps} id={id} />
        <ButtonBase
          {...buttonProps}
          data-test={dataTest}
          styles={styles}
          isPending={isPending}
          aria-label={ariaLabel}
        >
          {children}
        </ButtonBase>
      </>
    );
  }

  return (
    <>
      <input {...inputCaptureProps} id={id} />
      <StyledButton
        {...buttonProps}
        data-test={dataTest}
        buttonType={buttonType}
        isPending={isPending}
        aria-label={ariaLabel}
      >
        {children}
      </StyledButton>
    </>
  );
};

export default ButtonInputCapture;
